<template>
  <div class="root">
    <div class="father">
      <img src="../assets/img/资讯专区.png" alt />
      <div class="child">
        <div @click="toDetail('项目咨询')">
          <img src="../assets/img/项目查询.png" alt />
          <h3>项目咨询</h3>
          <p>请填写项目咨询信息</p>
        </div>
        <div @click="toDetail('项目政策法规查询')">
          <img src="../assets/img/政策法规查询.png" alt />
          <h3>政策法规咨询</h3>
          <p>请填写政策法规信息</p>
        </div>
        <div @click="toDetail('投诉与回复')">
          <img src="../assets/img/投诉与回复.png" alt />
          <h3>投诉与回复</h3>
          <p>请填写投诉与回复</p>
        </div>
      </div>
    </div>

    <div class="father">
      <img src="../assets/img/中心简介.png" alt />
      <div class="child2">
        <div v-if="aboutUsData">
          <p class="p-title">{{ aboutUsData.title }}</p>
          <div class="p-content" v-html="aboutUsData.content"></div>
        </div>
        <div v-else>
          <p class="p-title">
            {{
              (cityDetail.homeTitle
                ? cityDetail.cityName + cityDetail.homeTitle
                : cityDetail.cityName + "农村集体财产监督管理平台") + "简介"
            }}
          </p>
          <div>
            <p class="p-content">
              为培育和发展农村产权交易市场，规范农村产权交易行为，推动城乡生产要素流动，优化资源配置，设立
              {{
                cityDetail.homeTitle
                  ? cityDetail.cityName + cityDetail.homeTitle
                  : cityDetail.cityName + "农村集体财产监督管理平台"
              }}。中心内设综合部、交易部、财务部、信息部四个部门，为全市农村产权交易提供场所设施、政策咨询、信息发布、权能确认、组织交易、抵押融资，负责对中介组织、经纪人的管理和培训等相关职能的综合服务平台
            </p>
            <p class="p-content">
              中心采取“六统一”管理模式，即统一监督管理、统一交易规则、统一信息发布、统一交易鉴证、统一收费标准、统一平台建设。以丰富平台功能、完善交易制度、创新服务模式、破解“三农”难题、促进城乡统筹为目标，不断探索农村产权制度改革中重大问题的突破，为产权依法流转、要素对接资本、资本发展产业、产业引导富民创新经验和模式。
            </p>
            <p class="p-content">
              中心按照“总体规划、分步实施、先易后难、以点带面”的工作思路，目前开展的工作有我市辖区内的农村土地承包经营权，宅基地使用权，林地承包经营权，林木所有权、林木使用权，集体所有的水域、滩涂养殖权，农村集体资产所有权，农村集体经济组织股权，依法可以交易的房屋所有权，依法可以交易的农村集体经营性建设用地使用权，农业装备所有权（包括渔业船舶使用权），活体畜禽使用权，农产品期权，农业类知识产权，农村建设项目招标，产业项目招商和转让，其他依法可以交易的农村产权等。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkToken } from '../api/login.js'
import { getNewsDetail, getNewslist, publicityList } from '../api/mian.js'
import { cityDetail } from '../util/mainOption.js'

export default {
  data () {
    return {
      aboutUsData: null,
    }
  },
  created () { },
  mounted () {
    getNewslist({
      number: '006003',
      pageSize: 10,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then(res => {
      if (res.data.rows.length == 0) { return }
      getNewsDetail(
        { id: res.data.rows[0].id }
      ).then((res) => {
        this.aboutUsData = res.data.data
      })
    })
  },
  computed: {},
  watch: {},
  methods: {
    toDetail (str) {
      let token = localStorage.getItem('token')
      if (token) {
        checkToken().then((res) => {
          console.log(res)
          if (res.data.code == 200) {
            this.$router.push({
              name: str,
            })
          } else {
            this.$confirm('登录状态失效,请重新登录账号?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
              .then(() => {
                if (cityDetail.homeShowLogin) {
                  this.$router.push('/')
                } else {
                  this.$router.push('/login')
                }
              })
              .catch(() => { })
          }
        })
      } else {
        this.$confirm('请先登录账号?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (cityDetail.homeShowLogin) {
              this.$router.push('/')
            } else {
              this.$router.push('/login')
            }
          })
          .catch(() => { })
      }
    },
  },
}
</script>

<style scoped>
.root {
  min-height: 1180px;
  display: block;
  margin: 0 auto;
  padding: 40px 280px 0 280px;
  margin-bottom: 35px;
  width: 1300px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
}

.father {
  display: block;
  width: 1300px;
  height: auto;
}

.father > img {
  display: block;
  width: 100%;
  height: auto;
}

.child {
  padding: 40px 0 60px 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
  width: 1300px;
  height: auto;
}

.child div {
  display: block;
  width: 154px;
  height: 150px;
  text-align: center;
  cursor: pointer;
}

.child div h3 {
  padding: 13px 0;
  width: auto;
  height: 26px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 24px;
  color: #333333;
}

.child div p {
  width: 154px;
  height: 21px;
  font-size: 17px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 19px;
  color: #333333;
}

.child2 {
  padding: 40px 0 60px 0;
  display: block;
  width: 1300px;
  height: auto;
  font-size: 28px;
  color: #666;
}

.p-title {
  text-align: center;
  font-size: 38px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 20px;
}

.p-foot {
  /* border: 1px solid red; */
  padding: 30px 0;
}

.p-foot > p {
  text-indent: 2em;
  line-height: 60px;
  /* color: #333; */
  font-weight: 600;
}

.p-content {
  text-indent: 2em;
  line-height: 60px;
}

.child2_p {
  text-indent: 2em;
  width: 1300px;
  height: auto;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 36px;
  color: #666666;
  word-wrap: break-all;
  /* white-space: pre-wrap; */
}

.child3 {
  padding: 10px 0 60px 0;
  display: block;
  width: 1300px;
  height: auto;
}

.bumen {
  display: block;
  padding-top: 30px;
  width: 100%;
  height: 220px;
  overflow: hidden;
  /* background-color: red; */
}

.bumen > h3 {
  height: 18px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 18px;
  color: #333333;
}

.bumen > h3 > span {
  letter-spacing: 2px;
}

.bumen > p {
  padding: 20px 0 0 54px;
  width: 1246px;
  height: 36px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 36px;
  color: #999999;
}

.bumen > p > span {
  color: #333333;
}
</style>
